<template>
  <!-- <div class="containerLogos">
    <div class="d-flex align-items-center justify-content-between">
      <img
        class="img-fluid img-1"
        src="https://petronassyntium.petronas.com.br/img/LogomarcaSyntium.70ca9ab6.png"
        alt="Logo Logoplaste"
      />
      <img
        class="img-fluid img-1"
        src="https://petronassyntium.petronas.com.br/img/LogomarcaPetronas.8ffb3a19.png"
        alt="Logo Petronas"
      />
      
    </div>
  </div> -->
  <div class="header position-absolute w-100">
      <div class="container-fluid">
          <div class="d-flex justify-content-sm-end align-items-center pt-3">
            <img class="img-fluid img-right logo" src="@/assets/img/LOGO_PETRONAS_DARK.png" alt="PETRONAS">
          </div>
      </div>
  </div>
</template>

<script>
export default {};
</script>

<style  scoped>
.header {
  padding: 10px 80px;
  margin-top: 0px;
}

.header img{
  width: 90px;
  height: 95px;
}

.syntium{
  height: 70px;
}
.petronas{
  height: 80px;
}
@media(max-width: 991px){
  .header {
    padding: 0 50px;
  }
  .syntium{
    height: 60px;
  }
  .petronas{
    height: 70px;
  }
}

@media(max-width:767px) {
  .header {
    padding: 0 30px;
    margin-top: 30px;
  }
  .syntium{
    height: 60px;
  }
  .petronas{
    height: 80px;
  }

  .header img{
    width: 70px;
    height: 75px;
  }
}

@media(max-width:575px) {
  .header {
    padding: 0 15px;
    margin-top: 20px;
  }
  .syntium{
    height: 50px;
  }
  .petronas{
    height: 60px;
  }
}



</style>